import { Component, type ReactNode } from "react";

declare const __APP_VERSION__: string;
export class GameErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean; kind: string; copied: boolean }> {
  state = { failed: false, kind: "Error", copied: false };
  static getDerivedStateFromError(error: unknown) {
    const name = error instanceof Error ? error.name : "Error";
    return { failed: true, kind: ["NotFoundError", "TypeError", "RangeError", "ReferenceError"].includes(name) ? name : "Error", copied: false };
  }
  componentDidCatch() {
    console.error("ly_ui_error", this.diagnostic());
  }
  diagnostic() {
    // No error message, stack, URL query, account, answer or storage contents.
    return { site: "ly", version: __APP_VERSION__, errorType: this.state.kind, browser: navigator.userAgent };
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="game-recovery" role="alert">
      <h1>畫面暫時出了問題</h1>
      <p>可先恢復畫面繼續作答。恢復與重新載入都不會清空本機存檔。</p>
      <button onClick={() => this.setState({ failed: false })}>恢復畫面</button>
      <button onClick={() => window.location.reload()}>重新載入</button>
      <button onClick={async () => {
        try { await navigator.clipboard.writeText(JSON.stringify(this.diagnostic(), null, 2)); this.setState({ copied: true }); }
        catch { this.setState({ copied: false }); }
      }}>{this.state.copied ? "已複製，可貼入回饋表單" : "複製診斷摘要"}</button>
      <details><summary>診斷摘要（可手動複製）</summary><pre>{JSON.stringify(this.diagnostic(), null, 2)}</pre></details>
    </main>;
  }
}
